import BaseService from "../../store/services/base.service";
import { BBB, LOGIN, CLASSES, LICENSE, CBMS } from "../../utils";
import {
  setKneuraId,
  setUserId,
  setInstituteKneuraId,
  setInstituteId,
  setToken,
  setusername,
  setNotificationToken,
  getKneuraId,
} from "../../utils/authentication-access";
import { setTokenOnLogin } from "../../utils/api-authentication";
import { CONFERENCE_TYPE } from "../../store/services/live-class.service";
const SESSION_STORAGE_KEY = {
  BOARD_INFO: "boardinfo",
  CLASS_INFO: "classinfo",
};

// export const MODE = {
//   AUDIO_WITH_VIDEO: 0,
//   ONLY_AUDIO: 1,
// };
class Service {
  getBoardInfo() {
    const boardInfoStr = sessionStorage.getItem(SESSION_STORAGE_KEY.BOARD_INFO);
    const boardInfo = JSON.parse(boardInfoStr);
    return boardInfo;
  }

  setBoardInfo(boardInfoJson) {
    const boardInfoStr = JSON.stringify(boardInfoJson);
    sessionStorage.setItem(SESSION_STORAGE_KEY.BOARD_INFO, boardInfoStr);
  }

  getWhiteBoardID() {
    const { flow_id } = this.getBoardInfo();
    return flow_id;
  }

  getUserID() {
    return localStorage.getItem("kneuraId");
  }

  startMeeting() {
    return new Promise(async (resolve, reject) => {
      try {
        const whiteboardID = this.getWhiteBoardID();
        let {
          studentBBBURL,
          BBBSessionToken,
          conferenceType,
        } = await new BaseService().makeGetRequestGeneric(
          BBB.getStudentURL(whiteboardID)
        );
        return resolve({
          studentBBBURL,
          BBBSessionToken,
          conferenceType,
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  setBoardOnline({ isOnline }) {
    let boardinfo = this.getBoardInfo();
    boardinfo = { ...boardinfo, isOnline };
    this.setBoardInfo(boardinfo);
  }

  loginViaUserToken({ token }) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = LOGIN.loginViaToken(token);
        const { data } = await new BaseService().makePostRequestGeneric(url);
        sessionStorage.clear();
        setKneuraId(data.kneura_id);
        setUserId(data.userId);
        setInstituteKneuraId(data.instituteKneuraId);
        setInstituteId(data.instituteId);
        setToken(data.access_token);
        setTokenOnLogin(data.access_token);
        setusername(data.first_name);
        setNotificationToken(data.notificationToken);
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  getWhiteBoardInfo({ whiteboardID }) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = CLASSES.getWhiteBoardInfo(whiteboardID);
        const data = await new BaseService().makeGetRequestGeneric(url);
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  incrementLicense(conferenceType) {
    return new Promise(async (resolve, reject) => {
      try {
        if (conferenceType === CONFERENCE_TYPE.VIRTUAL_TUTORING) {
          await this.incrementLicenseVideo();
          return resolve(true);
        }
        await this.incrementLicenseAudio();
        return resolve(true);
      } catch (error) {
        return reject(error);
      }
    });
  }

  incrementLicenseAudio() {
    return new Promise(async (resolve, reject) => {
      try {
        const instituteId = localStorage.getItem("instituteKneuraId");
        const url = LICENSE.increment();
        await new BaseService().makePostRequestGeneric(url, {
          instituteId,
          type: "liveConferenceWithAudio",
          incrementBy: 1,
        });
        return resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  }

  incrementLicenseVideo() {
    return new Promise(async (resolve, reject) => {
      try {
        const instituteId = localStorage.getItem("instituteKneuraId");
        const url = LICENSE.increment();
        await new BaseService().makePostRequestGeneric(url, {
          instituteId,
          type: "liveConferenceWithAudioAndVideo",
          incrementBy: 1,
        });
        return resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  }
  isCbmsEnabled(sessionId) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = CBMS.isCbmsEnabled(sessionId);

        const data = await new BaseService().makeGetRequestGenericWithoutLoader(
          url
        );

       return resolve(data.data);
      } catch (error) {
        return reject(error);
      }
    });
  }
  saveAttendanceLog(sessionId,attendanceType='SESSION_JOINED'){
    return new Promise(async(resolve,reject)=>{
      try {
        const url = CBMS.saveAttendanceLog();
        const studentId=getKneuraId();
        const data = await new BaseService().makePostRequestGeneric(
          url,{
            studentId,
            sessionId,
            attendanceType,
          }
        );
       return resolve(data);
      } catch (error) {
        return reject(error);
      }
    })
  }
  saveSessionVideo(data){
    return new Promise(async(resolve,reject)=>{
      try {
        const url=CBMS.saveSessionVideo();
        const saveResponse=await new BaseService().makePostRequestGenericWithoutLoader(url,data,{
            'Content-Type': 'multipart/form-data',
            boundary:`${data._boundary}`,
            access_token:localStorage.getItem("usertoken")
          });
        return resolve(saveResponse);
      } catch (error) {
        return reject(error);
      }
    })
  }
}

const service = new Service();
export default service;
